<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">时间选择</span>
        <el-date-picker
          v-model="conditions.yearMonthDay"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择年月日"
        >
        </el-date-picker>
        <span class="fonints">货场</span>
      <div class="select_box">
            <m-select :list="selectastrict" v-model="huochangname"></m-select>
          </div>
        <div class="cheboxSty">
          <el-radio-group
            v-model="radio"
            @input="checkboxChnage"
          >
            <el-radio
              v-for="item in MyCheckboxList"
              :label="item.status"
              :key="item.name"
              >{{ item.name }}</el-radio
            >
          </el-radio-group>
        </div>
        <button class="buttons" @click="selectinfo">查询</button>
      </div>
      <div class="componentSty_content_table">
        <div class="mybox">
          <div class="tbNoMove">
            <table
              class="tabSty"
              cellpadding="0px"
              cellspacing="0px"
              v-if="tabledata"
            >
              <tr>
                <td
                  class="tdSty"
                  style="background: #f4f7fa"
                  v-for="(item, index) in titleList"
                  :key="index"
                >
                  {{ item }}
                </td>
              </tr>
            </table>
          </div>
          <div style="height: 45px"></div>
          <table class="tabSty" cellpadding="0px" cellspacing="1px">
            <template v-for="(item, name) in tabledata">
              <tr v-if="name != '合计'" :key="item.onlyKey">
                <th colspan="9">{{ name }}</th>
              </tr>
              <template v-if="name != '合计'">
                <tr
                  v-for="(item1, index1) in item"
                  :key="index1 + Math.random()"
                >
                  <td colspan="9">
                    <table class="tabSty" cellpadding="0px" cellspacing="0px">
                      <tr v-if="item1.pno">
                        <td class="tdSty">{{ index1 + 1 }}</td>
                        <td class="tdSty">{{ item1.shipname }}</td>
                        <td class="tdSty">{{ item1.pno }}</td>
                        <td class="tdSty">{{ item1.flowName }}</td>
                        <td class="tdSty">{{ item1.fleetName }}</td>
                        <td class="tdSty">{{ item1.completed }}</td>
                        <td class="tdSty">{{ item1.dispatchedCarNumber }}</td>
                        <td class="tdSty">{{ item1.auditCarNumber }}</td>
                        <td class="tdSty">{{ item1.cancelCarNumber }}</td>
                      </tr>
                      <tr v-else>
                        <td colspan="5">小计</td>
                        <td class="tdSty">{{ item1.completed }}</td>
                        <td class="tdSty">{{ item1.dispatchedCarNumber }}</td>
                        <td class="tdSty">{{ item1.auditCarNumber }}</td>
                        <td class="tdSty">{{ item1.cancelCarNumber }}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </template>
              <tr v-if="name == '合计'" :key="item.onlyKey">
                <td colspan="5" style="backgroun: #0057be">总计</td>
                <td class="tdSty" style="backgroun: #0057be">
                  {{ item[0].completed }}
                </td>
                <td class="tdSty" style="backgroun: #0057be">
                  {{ item[0].dispatchedCarNumber }}
                </td>
                <td class="tdSty" style="backgroun: #0057be">
                  {{ item[0].auditCarNumber }}
                </td>
                <td class="tdSty" style="backgroun: #0057be">
                  {{ item[0].cancelCarNumber }}
                </td>
              </tr>
            </template>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake } from "@/plugins/other.js";
import { mapMutations, mapState } from "vuex";
import mSelect from "@/components/mSelect";
export default {
  data() {
    return {
      listitem: [{ name: "统计分析" }, { name: "进港统计" }],
      conditions: {},
      selectastrict: [],
       huochangname: "全部",
      MyCheckboxList: [
        { name: "备货", status: "1" },
        { name: "提货", status: "2" },
        { name: "港内集疏", status: "3" }
      ],
      radio:'1',
      titleList: [
        "",
        "船名",
        "计划号",
        "流向",
        "代理",
        "完成数",
        "派车数",
        "审核数",
        "取消车数",
      ],
      tabledata: null,
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  created() {
    this.conditionsList[this.$route.path] ||
      this.createConditions({
        key: this.$route.path,
        val: {
          paymentChannel2: [],
        },
      });
    this.conditions = this.conditionsList[this.$route.path] || {
      paymentChannel2: [],
    };
     this.getselectastrict();
  },
  components: {
    mTitle,
    mSelect
  },
  methods: {
    ...mapMutations(["createConditions"]),
    async getTableMsg() {
      if (!this.conditions.yearMonthDay)
        return this.$message.info("请选择日期");
      // this.conditions.paymentChannel = this.conditions.paymentChannel2 + "";
      this.conditions.plantype=this.radio
       this.huochangname == "全部"
        ? (this.conditions.yard = null)
        : (this.conditions.yard = this.huochangname);
        console.log( this.conditions);
      const { data } = await this.$http(
        "api1",
        "/statistics/carsuttlenumber/statisticsCarCountByPnoYardFleet",
        "post",
        this.conditions
      );
      if (data.code != 0) return this.$message.error(data.msg);
      let obj = {};
      Array.isArray(data.data) &&
        data.data.forEach((item) => {
          item.onlyKey = NaN;
          !obj[item.yard] && (obj[item.yard] = []);
          obj[item.yard] && obj[item.yard].push(item);
        });
      this.tabledata = obj;
    },
     async getselectastrict() {
      const { data } = await this.$http("api1", "/sys/dic/list", "get", {
        dictionaryType: "货场",
      });
      if (!data.data) return;
      this.selectastrict = ["全部"];
      data.data.forEach((item) => {
        this.selectastrict.push(item.val);
      });
    },
    checkboxChnage(event) {
      this.conditions.plantype = event;
      this.getTableMsg();
    },
    selectinfo() {
      antiShake((_) => {
        this.getTableMsg();
      });
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
<style lang="scss" scoped>
.mybox {
  height: 100%;
  overflow: auto;
  .tbNoMove {
    position: absolute;
    width: 100%;
    height: 45px;
  }
  .tabSty {
    font-size: 80%;
    word-break: break-all;
    table-layout: fixed;
    width: 100%;
    background-color: #adadad;
    td,
    th {
      text-align: center;
      height: 45px;
      background-color: #fdfdfd;
    }
    .tdSty {
      border-bottom: 1px solid #adadad;
      border-left: 1px solid #adadad;
    }
    .tdSty2 {
      border-left: 1px solid #adadad;
    }
  }
}
</style>
